import { createContext, useContext, useEffect, useState } from "react";
import api, { setAuthToken, clearAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // httpOnly cookies are sent automatically via withCredentials: true.
    // No localStorage read needed — if the cookie is valid the server returns the user.
    api.get("/auth/me")
      .then((r) => { setUser(r.data); setLoading(false); })
      .catch(() => { clearAuthToken(); setUser(null); setLoading(false); });
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    const { user: u, access_token } = res.data;
    setAuthToken(access_token); // in-memory only — no localStorage
    setUser(u);
    return u;
  };

  const logout = async () => {
    clearAuthToken();
    try {
      await api.post("/auth/logout"); // clears httpOnly cookies server-side
    } catch (e) {
      console.debug("Logout API call failed (safe to ignore):", e?.message);
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
